import { first } from 'rxjs/operators';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Input, OnInit } from '@angular/core';
import { AlertService } from '@app/_services';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { OrderTaxService } from '../order-tax.service';
import { OrderTax } from '../order-tax';
import { OrderTaxComponent } from '../order-tax/order-tax.component';

@Component({
    selector: 'app-order-tax-list',
    templateUrl: './order-tax-list.component.html',
    styleUrls: ['./order-tax-list.component.css'],
    providers: [MessageService, ConfirmationService, { provide: MAT_DIALOG_DATA, useValue: {} }],
    // make column heading sticky
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`],
    standalone: false
})
export class OrderTaxListComponent implements OnInit {
	chargeTypes: any;
	constructor(
		private orderTaxService: OrderTaxService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private dialog: MatDialog,
	) {
		this.statuses = orderTaxService.statuses;
		this.chargeTypes = orderTaxService.chargeTypes;
	}



	// data
	@Input() showFilter = true;
	@Input() showPagination = true;
	@Input() outlineNewButton = true;
	orderTaxs: any;
	orderTax: OrderTax;

	// paging
	first = 0;
	rows = 50;

	// list
	datasource: any;

	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	multiSortMeta = [];

	// forms
	formLoading = false;

	statuses: any;

	columns: any[] = [
		{ field: 'orderTaxId', header: 'Id', width: 'auto' },
		{ field: 'status', header: 'Status', width: 'auto' },
		{ field: 'name', header: 'Name', width: 'auto' },
		{ field: 'valueAMT', header: 'Amount', width: 'auto' },
		{ field: 'valuePCT', header: 'Percentage', width: 'auto' },
		{ field: 'active', header: 'Active', width: 'auto' },
	];

	ngOnInit(): void {
		try {
			// default sort of list
			this.multiSortMeta = [];
			this.multiSortMeta.push({ field: 'createDate', order: 0 });
		}
		catch (error) {
			console.log('Error: ' + error);
		}
	}

	/*********
	 * Delete Button
	 *
	 */
	onRowDelete(event: any) {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + event.orderTaxId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete(event);
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}


	/*********
	 * Lazy Load All Data
	 *
	 */
	loadLazy(event: LazyLoadEvent) {
		try {
			this.loading = true;
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			/*
			*
			* Default Sort
			*/
			// https://stackoverflow.com/questions/679915/how-do-i-orderTax-for-an-empty-javascript-object
			// if we are NOT filtering and we are NOT sorting, apply a default sort
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({ field: 'createDate', order: -1 });
			}

			const pageNumber = Math.round(event.first / event.rows);
			this.orderTaxService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					(res: any) => {
						this.datasource = res.data.reviews;
						this.recordTotal = res.page.recordTotal;
						this.orderTaxs = res.data.taxs;
						console.log(JSON.stringify(res.page));
					},
					(err: any) => {
						console.log('reviews list error!: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.loading = false; }
				);

			if (this.datasource) {
				this.orderTaxs = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
		}
	}

	getStatus() {
		return
	}

	/*********
	 * onRowSelect()
	 * Used to handle row click (to edit, link, etc)
	 */
	onRowSelect(event: any) {
		console.log('onRowSelect: ' + JSON.stringify(event));
		this.onOpenFormEdit(event.data);
	}

	// handled in rate-bucket-form
	formAdd() { }


	/*********
	 * formUpdate()
	 * Used for row editing
	 */
	formUpdate(orderTax: OrderTax) {
		try {
			this.formLoading = true;
			this.orderTaxService.update(orderTax)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
						this.orderTaxs.map((orderTax, i) => {
							if (orderTax.orderTaxId === res.data.orderTax.orderTaxId) {
								this.orderTaxs[i] = res.data.orderTax;
							}
						});
						// this.alertService.success(res, true);
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					},
					(err: any) => {
						console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
	 * formDelete()
	 * Used for row editing
	 */
	formDelete(orderTax: any) {
		try {
			// stop here if form is invalid
			console.log('Delete Submitted: ' + JSON.stringify(orderTax));

			this.formLoading = true;
			this.orderTaxService.delete(orderTax.orderTaxId)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Delete SUCCESS: ' + JSON.stringify(res));
						this.orderTaxs.splice(this.orderTaxs.indexOf(orderTax), 1);
						this.recordTotal = this.orderTaxs.length;
						this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'OrderTax ' + orderTax.orderTaxId + ' Deleted', life: 3000 });
					},
					(err: any) => {
						console.log('Rate-Bucket-Delete  FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Delete Failed', detail: 'OrderTax ' + orderTax.orderTaxId + ' could not be deleted.  Be sure there are no assigned properties to this bucket.', life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
		 * Add New Button
		 *
		 */
	onOpenFormAdd() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Add OrderTax'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(OrderTaxComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.addOrderTaxCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/*********
		* Edit Button
		*
		*/
	onOpenFormEdit(orderTax: OrderTax) {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			orderTax: orderTax,
			title: 'Edit OrderTax'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(OrderTaxComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);
				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.updateOrderTaxCB(data);

				// close the dialogBox
				// dialogRef.close();
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.deleteOrderTaxCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/**
	   *
	   * Dialog from Form Callbacks
	   * To edit the list show add/edit/delete in real time from the popup form
	   *
	   */
	addOrderTaxCB(orderTax: OrderTax) {
		console.log('Adding OrderTax: ' + JSON.stringify(orderTax));
		// if we don't have a orderTaxs array yet...
		if (!this.orderTaxs) {
			this.orderTaxs = [];
		}
		// unshift adds to the front of the array (), push adds to the back
		this.orderTaxs.unshift(orderTax);

		// no idea what this is but it is required to update the array
		this.orderTaxs = [...this.orderTaxs];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'OrderTax ' + orderTax.orderTaxId + ' Added', life: 3000 });
	}

	updateOrderTaxCB(orderTax: OrderTax) {
		console.log('Updating OrderTax: ' + JSON.stringify(orderTax));
		let itemIndex = this.orderTaxs.findIndex((item: any) => item.orderTaxId === orderTax.orderTaxId);
		this.orderTaxs[itemIndex] = orderTax;

		// no idea what this is but it is required to update the array
		this.orderTaxs = [...this.orderTaxs];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'OrderTax ' + orderTax.orderTaxId + ' Updated', life: 3000 });
	}

	deleteOrderTaxCB(orderTax: OrderTax) {
		console.log('Removing OrderTax: ' + orderTax);
		this.orderTaxs.splice(this.orderTaxs.indexOf(orderTax), 1);
		this.recordTotal = this.orderTaxs.length;

		// no idea what this is but it is required to update the array
		this.orderTaxs = [...this.orderTaxs];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'OrderTax ' + orderTax.orderTaxId + ' Deleted', life: 3000 });
	}

	/**********
	 *
	 * PAGINATOR FUNCTIONS
	 */
	next() { this.first = this.first + this.rows; }
	prev() { this.first = this.first - this.rows; }
	reset() { this.first = 0; }
	isLastPage(): boolean { return this.orderTaxs ? this.first === (this.orderTaxs.length - this.rows) : true; }
	isFirstPage(): boolean { return this.orderTaxs ? this.first === 0 : true; }

	get Statuses() {
		return this.statuses;
	}

	getStatusName(orderTax: any) {
		if (orderTax?.status || orderTax?.status == 0) {
			const status = this.statuses.find((e: any) => e.value == orderTax.status);
			return status.name;
		}
		else {
			return '';
		}
	}

	getChargeType(orderTax: any) {
		if (orderTax?.chargeType) {
			const status = this.chargeTypes.find((e: any) => e.value == orderTax.chargeType);
			return status.name;
		}
		else {
			return '';
		}
	}

	reloadPage() {
		window.location.reload();
	}

	showPaginator()
	{
		return true;
	}
}
